import React, { createContext, useContext } from "react";

const MapContext = createContext();

export const MapProvider = ({ children }) => {
  const calculateSitePortBandwidthBreakdown = (siteData) => {
    if (!siteData?.structures) return { current: 0, future: 0, total: 0 };

    let currentTotal = 0;
    let futureTotal = 0;

    siteData.structures.forEach((structure) => {
      if (!structure?.circuits) return;

      structure.circuits.forEach((circuit) => {
        const portBandwidth = parseInt(circuit.portBandwidth) || 0;
        const status = circuit.status?.toLowerCase() || "";

        if (status === "active") {
          currentTotal += portBandwidth;
        } else if (status === "wip") {
          futureTotal += portBandwidth;
        }
      });
    });

    return {
      current: currentTotal,
      future: futureTotal,
      total: currentTotal + futureTotal,
    };
  };

  const calculateSiteMrcCostBreakdown = (siteData) => {
    if (!siteData?.structures) return { current: 0, future: 0, total: 0 };

    let currentTotal = 0;
    let futureTotal = 0;

    siteData.structures.forEach((structure) => {
      if (!structure?.circuits) return;

      structure.circuits.forEach((circuit) => {
        const mrcCost = parseInt(circuit.mrcBaseline) || 0;
        const status = circuit.status?.toLowerCase() || "";

        if (status === "active") {
          currentTotal += mrcCost;
        } else if (status === "wip") {
          futureTotal += mrcCost;
        }
      });
    });

    return {
      current: currentTotal,
      future: futureTotal,
      total: currentTotal + futureTotal,
    };
  };

  const formatBandwidth = (totalKbps) => {
    if (totalKbps === 0) return "0 Kbps";
    if (totalKbps >= 1000000) return `${(totalKbps / 1000000).toFixed(1)} Gbps`;
    if (totalKbps >= 1000) return `${(totalKbps / 1000).toFixed(1)} Mbps`;
    return `${totalKbps} Kbps`;
  };

  const formatCost = (total) => {
    if (total === 0) return "0.00";

    return new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
    }).format(total);
  };

  const getSiteBreakdown = (site) => ({
    bandwidth: formatBandwidth(
      calculateSitePortBandwidthBreakdown(site).current
    ),
    cost: formatCost(calculateSiteMrcCostBreakdown(site).current),
  });

  return (
    <MapContext.Provider
      value={{
        getSiteBreakdown,
        formatBandwidth,
        formatCost,
        calculateSitePortBandwidthBreakdown,
        calculateSiteMrcCostBreakdown,
      }}
    >
      {children}
    </MapContext.Provider>
  );
};

export const useMapContext = () => {
  const context = useContext(MapContext);
  if (!context) throw new Error("useMapContext must be used within MapContext");
  return context;
};
